/* Subtle fade-in animation for the alert popup */
body .swal2-show {
  animation: fadeIn 0.15s ease-in-out;
}

/* Subtle fade-out animation for the alert popup */
body.swal2-hide {
  animation: fadeOut 0.1s ease-in-out;
}

/* Subtle fade-in animation for the backdrop */
body .swal2-backdrop-show {
  animation: backdropFadeIn 0.15s ease-in-out;
}

/* Subtle fade-out animation for the backdrop */
body .swal2-backdrop-hide {
  animation: backdropFadeOut 0.1s ease-in-out;
}

body.swal2-no-backdrop .swal2-container {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

/* Font styling to match the app */
.swal2-popup {
  font-family: "Inter-Regular", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  padding-top: 1.2rem;
}

.swal2-title {
  font-family: "Inter-SemiBold", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 18px;
}

.swal2-content {
  font-family: "Inter-Regular", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 14px;
}

.swal2-confirm,
.swal2-deny,
.swal2-cancel {
  font-family: "Inter-Medium", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-weight: 500;
}

.swal2-confirm {
  background-image: linear-gradient(1.5708rad, rgb(218, 82, 99), rgb(242, 153, 81));
  color: #fff;
}

/* Keyframe animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}

@keyframes backdropFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.4;
  }
}

@keyframes backdropFadeOut {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 0;
  }
} 